import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { Produktmatris } from "../Produktmatris";
import { PrismatrisCell } from "./prismatrisCell";

export class PrisCell extends PrismatrisCell {
    value: number;
    prismatris: Produktmatris;

    constructor(
        prismatris: Produktmatris,
        form: UntypedFormGroup,
        flags?: Cellstyle) {
        super(prismatris, form, prismatris.pris, flags, (pm) => prismatris.pris = pm.newValue);
    }
}
